import { FlexColumn } from "@/components/Flex";
import { UserDetails, Folder } from "@knowt/syncing/graphql/schema";
import ProfileHeader from "./ProfileHeader/ProfileHeader";
import ProfileGamificationCards from "./ProfileGamificationCards";
import ProfileUserContentItems from "./ProfileUserContentItems";

type ProfileMainContentProps = {
    userInfo: UserDetails;
    isOwner: boolean;
    items: any[];
    folders: Folder[];
};

const ProfileMainContent = ({ userInfo, isOwner, items, folders }: ProfileMainContentProps) => {
    return (
        <FlexColumn style={{ flex: 1 }}>
            <ProfileHeader user={userInfo} isEditable={isOwner} />
            <ProfileGamificationCards ownerDetails={userInfo} isOwner={isOwner} />
            <div style={{ paddingBottom: "2.4rem" }} data-testid="auto-id-57dca6c4-d580-4ecf-9755-056c3b225f5d" />
            {!isOwner && (
                <ProfileUserContentItems items={items} folders={folders} ownerDetails={userInfo} isOwner={isOwner} />
            )}
        </FlexColumn>
    );
};

export default ProfileMainContent;
